import { createPvCountUpParam } from '@doda/common/src/logics/pvCountUp/createPvCountUp';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import { queryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { postPvCountUp } from '@doda/common/src/services/pvCountUpAPI';
import { useEffect } from 'react';
import { isBot } from '../../utils/isBot';

/**
 * 求人詳細PVカウントアップ処理
 * @param {QueryParams} queryParams - クエリパラメータのオブジェクト。
 * @param {boolean} jid - 求人ID
 * @param {string} wmuid - 原稿ID
 */
export const usePvCountUp = ({
  jid,
  wmuid,
}: {
  jid: string;
  wmuid: string;
}) => {
  const queryParams = useAppSelector(queryParamsSelector);
  const loginStatus = useAppSelector(loginStatusSelector);
  const data = createPvCountUpParam({
    queryParams,
    loginStatus,
    wmuid,
    device: 'PC',
  });
  useEffect(() => {
    // UAにbotが含まれている場合は、カウントアップしない
    if (isBot()) return;
    postPvCountUp(data, jid).catch((axiosError) => {
      window.DD_LOGS?.logger.error(
        `postPvCountUp failed: ${JSON.stringify(axiosError.response?.data)}, jid: ${jid}, data: ${JSON.stringify(data)}`
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
